<style scoped>
.br-10 {
  padding: 10px;
  border-radius: 10px;
}
</style>

<template>
  <v-container fluid fill-height row>
    <v-layout justify-center align-start>
      <v-flex xl4 lg6 md7 sm10 xs12>
        <v-form @submit.prevent="submitForm($event)">
          <v-card class="br-10 text-center elevation-3">
            <v-layout class="pa-3" column wrap >
              <span class="title primary--text text--darken-2"><strong>{{ $t('complaint_proof') }}</strong></span>
              <span class="subheading grey--text text--darken-2 text-xs-left pt-2">{{ $t('select_mode') }}:</span>
              <v-layout justify-center :column="$vuetify.breakpoint.xsOnly">
                <v-btn v-if="isCordova" block color="primary" :class="optionUpload === 'camera' ? 'white--text text' : 'black--text text'" style="margin-left: 2px" :outlined="optionUpload !== 'camera'" :text="optionUpload !== 'camera'" rounded large @click="setOptionUpload({ optionUpload: 'camera' })">{{ $t('camera') }}</v-btn>
                <v-btn block color="primary" :class="optionUpload === 'attachment' ? 'white--text text' : 'black--text text'" style="margin-left: 2px" :outlined="optionUpload !== 'attachment'" :text="optionUpload !== 'attachment'" rounded dark large @click="setOptionUpload({ optionUpload: 'attachment' })">{{ $t('attach_file') }}</v-btn>
              </v-layout>
              <v-layout row wrap class="pt-2" v-if="optionUpload === 'camera' && isCordova">
                <v-flex xs12 class="pa-2" @click="startCameraAbove()">
                  <v-card id="cameraBox" dark color="grey lighten-2" style="height: 180px; border: 1px solid red; outline: 2px dashed indigo;" class="br-12 elevation-0" v-if="!camera">
                    <v-card-text class="px-0">
                      <v-icon v-if="!imgsrc" style="font-size: 48px;" color="grey">fa-camera</v-icon><br>
                      <span class="black--text font-weight-medium">{{ $t('attach_image') }}</span>
                      </v-card-text>
                    <img v-if="imgsrc" :src="imgsrc" style="max-width: 80%; max-height: 60%;"/>
                  </v-card>
                  <v-card id="cameraBox" dark color="transparent" style="height: 180px; border: 1px solid red; outline: 2px dashed indigo;" class="br-12 pt-3 elevation-0" v-if="camera"></v-card>
                </v-flex>
                <v-layout justify-end xs12>
                  <v-btn color="primary" dark rounded large @click="takePicture()" :disabled="!camera">{{ $t('capture') }}</v-btn>
                </v-layout>
              </v-layout>
              <v-layout row wrap class="pt-2" v-if="optionUpload === 'attachment'">
                <v-flex xs12 class="pa-2" @click="submitAttachment()">
                  <v-card dark color="grey lighten-2" style="height: 180px; border: 1px solid red; outline: 2px dashed indigo;" class="br-12 elevation-0">
                    <v-card-text class="px-0">
                      <span class="black--text font-weight-bold">{{ $t('attach_image') }}</span>
                      <input id="attachment" name="attachment" hidden :data-vv-as="$t('attach_image')" @change="loadFile($event)" type="file" v-validate="rules.file"><br>
                    </v-card-text>
                    <img id="output" style="max-width: 80%; max-height: 60%;"/>
                  </v-card>
                </v-flex>
                <span class="pt-2 caption primary--text font-weight-bold">*Required / Perlu ada lampiran aduan*</span>
              </v-layout>
            </v-layout>
          </v-card>
          <br>
          <v-card class="br-10 text-center elevation-3">
            <v-layout class="pa-3" column wrap >
              <span class="title primary--text text--darken-2"><strong>{{ $t('complaint_form') }}</strong></span>
                <v-select prepend-icon="fa-flag fa-lg" :error-messages="errors.collect('category')" :items="category" :value="data.category" @input="patchData({ category: $event })" :label="$t('category')" name="category" required v-validate="rules.category"></v-select>
                <v-textarea prepend-icon="fa-map-marker fa-lg" :error-messages="errors.collect('location')" :data-vv-as="$t('location')" name="location" :value="data.location" @input="patchData({ location: $event })" :label="$t('location')" required type="text" v-validate="rules.location"></v-textarea>
                <v-textarea prepend-icon="fa-file fa-lg" :error-messages="errors.collect('description')" :data-vv-as="$t('description')" :label="$t('description')" :value="data.description" @input="patchData({ description: $event })" name="description" v-validate="rules.description" type="text" required></v-textarea><br>
            </v-layout>
          </v-card>
          <br>
          <v-card class="br-10 text-center elevation-3">
            <v-layout class="pa-3" column wrap >
              <span class="title primary--text text--darken-2"><strong>{{ $t('complainant_detail') }}</strong></span>
                <v-text-field prepend-icon="fa-user-circle fa-lg" :error-messages="errors.collect('full_name')" clearable :value="data.complainant.full_name" @input="patchComplainant({ full_name: $event })" :label="$t('full_name')" name="full_name" required type="text" :disabled="hasSession" v-validate="rules.full_name"></v-text-field>
                <v-text-field class="pt-2" prepend-icon="fa-id-card fa-lg" :error-messages="errors.collect('ic_num')" clearable :data-vv-as="$t('ic_num')" :mask="'######-##-####'" name="ic_num" :value="data.complainant.ic_num" :counter="14" @input="patchComplainant({ ic_num: $event })" :label="$t('ic_num')" required type="text" :disabled="hasSession" return-masked-value v-validate="rules.ic_no"></v-text-field>
                <v-text-field class="pt-2" prepend-icon="fa-phone-square fa-lg" :error-messages="errors.collect('phone_no')" :data-vv-as="$t('phone_no')" :label="$t('phone_no')" :value="data.complainant.phone" @input="patchComplainant({ phone: $event })" name="phone_no" v-validate="rules.phone" type="number" :disabled="hasSession" required></v-text-field>
                <v-text-field class="pt-2" prepend-icon="fa-envelope fa-lg" :error-messages="errors.collect('email_address')" :data-vv-as="$t('email_address')" :value="data.complainant.email" @input="patchComplainant({ email: $event })" :label="$t('email_address')" name="email_address" required type="text" :disabled="hasSession" v-validate="rules.email_address"></v-text-field>
            </v-layout>
          </v-card>
          <v-layout justify-end mt-2>
            <v-btn :block="$vuetify.breakpoint.xsOnly" color="primary" large rounded type="submit" :disabled="isLoading" :loading="isLoading">{{ $t('submit') }}</v-btn>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  beforeRouteLeave (to, from, next) {
    if (this.isCordova) CameraPreview.stopCamera()
    this.resetData()
    next()
  },
  computed: {
    ...mapGetters({
      hasName: 'auth/hasName',
      hasSession: 'auth/hasSession',
      isLoading: 'complaint/isLoading'
    }),
    ...mapState({
      user: (state) => state.auth.data,
      camera: (state) => state.complaint.camera,
      data: (state) => state.complaint.data,
      optionUpload: (state) => state.complaint.optionUpload,
      file: (state) => state.complaint.file,
      rules: (state) => state.complaint.rules
    }),
    isCordova () {
      return window.hasOwnProperty('cordova')
    },
    isValid: function () {
      return Object.keys(this.fields).every((key) => this.fields[key].valid)
    },
    category: function () {
      let category = [
        { text: this.$i18n.t('anjing_terbiar'), value: 'anjing_terbiar' },
        { text: this.$i18n.t('bangkai_binatang'), value: 'bangkai_binatang' },
        { text: this.$i18n.t('jalan_rosak'), value: 'jalan_rosak' },
        { text: this.$i18n.t('bangunan'), value: 'bangunan' },
        { text: this.$i18n.t('halangan_awam'), value: 'halangan_awam' },
        { text: this.$i18n.t('kawalan_perniagaan'), value: 'kawalan_perniagaan' },
        { text: this.$i18n.t('bising'), value: 'bising' },
        { text: this.$i18n.t('bau'), value: 'bau' },
        { text: this.$i18n.t('kebersihan'), value: 'kebersihan' },
        { text: this.$i18n.t('lampu_awam'), value: 'lampu_awam' },
        { text: this.$i18n.t('longkang_pecah'), value: 'longkang_pecah' },
        { text: this.$i18n.t('longkang_tersumbat'), value: 'longkang_tersumbat' },
        { text: this.$i18n.t('pembakaran_terbuka'), value: 'pembakaran_terbuka' },
        { text: this.$i18n.t('perkhidmatan_sampah'), value: 'perkhidmatan_sampah' },
        { text: this.$i18n.t('pokok_tumbang'), value: 'pokok_tumbang' },
        { text: this.$i18n.t('rumah_setinggan'), value: 'rumah_setinggan' },
        { text: this.$i18n.t('rumput_tidak_berpotong'), value: 'rumput_tidak_berpotong' },
        { text: this.$i18n.t('ternakan'), value: 'ternakan' },
        { text: this.$i18n.t('lain-lain'), value: 'lain-lain' }
      ]
      return category
    }
  },
  data () {
    return {
      imgsrc: null
    }
  },
  created: async function () {
    this.$store.commit('loading/setPageLoading', { loading: false })
    await this.$store.dispatch('auth/fetchData')
    if (this.user.name) {
      this.$store.dispatch('complaint/patchComplainant', { email: this.user.name })
      this.$store.dispatch('complaint/patchComplainant', { phone: this.user.phone })
      this.$store.dispatch('complaint/patchComplainant', { full_name: this.user.full_name })
      this.$store.dispatch('complaint/patchComplainant', { ic_num: this.user.ic_num })
    }

    navigator.geolocation.getCurrentPosition(function (position) {
      const geolocation = {
        coords: {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          altitude: position.coords.altitude,
          accuracy: position.coords.accuracy,
          altitudeAccuracy: position.coords.altitudeAccuracy,
          heading: position.coords.heading,
          speed: position.coords.speed
        },
        timestamp: position.timestamp
      }
      this.$store.dispatch('complaint/patchData', { geolocation })
    }.bind(this), (error) => { alert(error.message) }, { enableHighAccuracy: true })

    window.addEventListener('scroll', this.handleScroll)
    if (this.optionUpload === 'camera') {
      this.startCameraAbove()
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    ...mapActions({
      attachFile: 'complaint/attachFile',
      patchComplainant: 'complaint/patchComplainant',
      patchData: 'complaint/patchData',
      resetData: 'complaint/resetData',
      submitData: 'complaint/submitData',
      updateData: 'complaint/updateData'
    }),
    ...mapMutations({
      setCamera: 'complaint/setCamera',
      setFile: 'complaint/setFile',
      setOptionUpload: 'complaint/setOptionUpload'
    }),
    loadFile (event) {
      var FileSize = event.target.files[0].size / 1024 / 1024
      if (FileSize > 50) {
        alert('File size exceeds 50 MB')
      } else {
        this.setFile({ file: event.target.files[0] })
        var output = document.getElementById('output')
        output.src = URL.createObjectURL(event.target.files[0])
      }
    },
    handleScroll () {
      if (window.scrollY > 0) {
        this.stopCameraAbove()
      } else {
        if (this.file === null && this.optionUpload === 'camera') {
          this.startCameraAbove()
        }
      }
    },
    submitForm: async function ($event) {
      if (!(await this.$validator.validateAll())) return
      const response = await this.submitData()
      this.resetData()
      this.$router.push(`/complaint/detail/${response.id}`)
    },
    submitAttachment: async function ($event) {
      document.getElementById('attachment').click()
    },
    startCameraAbove: async function () {
      await this.setCamera({ camera: true })
      const width = document.getElementById('cameraBox').offsetWidth
      const x = document.getElementById('cameraBox').getBoundingClientRect().left
      const y = document.getElementById('cameraBox').getBoundingClientRect().top
      const cameraOption = {
        x: x,
        y: y,
        width: width,
        height: 180,
        camera: CameraPreview.CAMERA_DIRECTION.BACK,
        tapFocus: true,
        previewDrag: false,
        tapPhoto: false
      }
      CameraPreview.startCamera(cameraOption)
    },
    stopCameraAbove: function () {
      this.setCamera({ camera: false })
      CameraPreview.stopCamera()
    },
    dataURItoBlob: function (dataURI) {
      var byteString
      if (dataURI.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(dataURI.split(',')[1])
      } else {
        byteString = unescape(dataURI.split(',')[1])
      }
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

      var ia = new Uint8Array(byteString.length)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }

      return new Blob([ia], { type: mimeString })
    },
    takePicture: function () {
      CameraPreview.takePicture({ width: 640, height: 640, quality: 85 }, function (imgData) {
        const file = this.dataURItoBlob('data:image/jpeg;base64,' + imgData[0])
        this.setFile({ file })
        this.setCamera({ camera: false })
        CameraPreview.stopCamera()
        this.imgsrc = 'data:image/jpeg;base64,' + imgData[0]
      }.bind(this))
    }
  },
  watch: {
    optionUpload: function (value) {
      if (value === 'attachment') {
        CameraPreview.stopCamera()
      } else {
        if (this.file === null) {
          this.startCameraAbove()
        }
      }
    }
  }
}
</script>
